import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { ActionIcon, Anchor, Text, Modal,  } from '@mantine/core';
import { IconInfoCircle, IconX } from '@tabler/icons-react';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { HelpTip } from "../../components/GeneralComponent/GeneralComponent";

export function TestInfo({ pageId }:any) {
  const navigate = useNavigate();
  const [testInfoModalOpen, setTestInfoModalOpen] = useState(false);
  const [testInfoPageLink, setTestInfoPageLink] = useState('');
  const [testInfoPageTitle, setTestInfoPageTitle] = useState('');
  const [testInfoTestTime, setTestInfoTestTime] = useState('');
  const [testInfoOriginalLaunch, setTestInfoOriginalLaunch] = useState('');
  const [testInfoTestType, setTestInfoTestType] = useState('');
  const [testInfoVisioptTestId, setTestInfoVisioptTestId] = useState('');
  const [testsName, setTestsName] = useState('');


  const handleTestInfoOpenModal = (value:any) => {
    if (!pageId) {
      navigate('/review-tests');
      return;
    }
    TestsApi.gettestinfo({
      page_id:pageId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setTestInfoPageLink(data.data.page_link);
        setTestInfoPageTitle(data.data.page_title);
        setTestInfoTestTime(data.data.test_time);
        setTestInfoOriginalLaunch(data.data.original_launch_date || '');
        setTestInfoTestType(data.data.test_type);
        setTestInfoVisioptTestId(data.data.visiopt_test_id);
        setTestsName(data.data.tests_name);
        setTestInfoModalOpen(true);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  const handleTestInfoCloseModal = () => {
    setTestInfoModalOpen(false);
  };


  return (
    <>
      <ActionIcon
        variant="default"
        size="lg"
        sx={(theme) => ({
           backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#fff",
         })}
        title="Test Info"
        ml={5}
        onClick={() => handleTestInfoOpenModal(1)}
      >
        <IconInfoCircle size="1.1rem" />
      </ActionIcon>     
 
      <Modal.Root opened={testInfoModalOpen} onClose={handleTestInfoCloseModal} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title><Text weight={500}>TEST INFORMATION <HelpTip helpId={203} /></Text></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <form>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Test ID:</Text>
                <Text size="sm" fz={14}>{testInfoVisioptTestId}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Test Name:</Text>
                <Text size="sm" fz={14} mr={5}>{testsName}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Tested Page:</Text>
                <Anchor href={testInfoPageLink} target="_blank" fw={500} mr={5} mt={-2}>{testInfoPageTitle} </Anchor>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Test Type:</Text>
                <Text size="sm" fz={14} mr={5}>{testInfoTestType}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <Text size="sm" fz={14} fw={500} mr={5} style={{ minWidth: 100 }}>Test Start on:</Text>
                <div>
                  <Text size="sm" fz={14}>{testInfoTestTime}</Text>
                  {testInfoOriginalLaunch !== '' && (
                    <Text size="xs" fz={12} c="dimmed" mt={2}>
                      Originally launched {testInfoOriginalLaunch} · Reset on {testInfoTestTime}
                    </Text>
                  )}
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>      
    </>
  );
}